const LANGUAGES = [
    {code: "en", name: "English", dir: "ltr", emoji: "🇬🇧"},
    {code: "es", name: "Español", dir: "ltr", emoji: "🇪🇸"},
    {code: "pl", name: "Polski", dir: "ltr", emoji: "🇵🇱"},
    {code: "sl", name: "Slovenščina", dir: "ltr", emoji: "🇸🇮"},
    {code: "mk", name: "Македонски", dir: "ltr", emoji: "🇲🇰"},
    {code: "el", name: "Ελληνικά", dir: "ltr", emoji: "🇬🇷"}
]

export default LANGUAGES;